export default __webpack_public_path__ + "static/blockbites-logo-grey-6ccf19c92230782cef5de5cd4dc4b44e.svg";